module.exports = __webpack_public_path__ + "images/shop/favicon-kfzteile-com/android-chrome-192x192.png";